import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { FaBed, FaUserFriends } from "react-icons/fa"
import Separator from "../../utils/separator"
export default function RentalCard({
  reference,
  cover,
  name,
  services,
  price,
  beds,
  guests,
  slug,
}) {
  return (
    <div className="bg-white rounded-md">
      <div className="relative p-2">
        <span className="absolute z-10 left-3 bg-white rounded-md p-2 text-xs text-primary italic bottom-3">
          <strong>Ref:</strong> {reference}
        </span>
        <Link to={`/rentals/${slug.current}`}>
          <GatsbyImage
            image={cover.asset.gatsbyImageData}
            alt={name}
            className="aspect-video rounded-md object-cover"
          />
        </Link>
      </div>
      <div className="px-2 py-4 flex flex-col gap-2">
        <h3 className="text-base md:text-2xl">{name}</h3>

        <p className="text-xs">{services}</p>

        <div className="flex justify-between items-center">
          <p className="font-serif">From {Separator(price)}/week</p>
          <Link
            className="px-6 py-2 text-xs text-primary bg-secondry rounded-md"
            to={`/rentals/${slug.current}`}
          >
            Explore
          </Link>
        </div>
        <div className="inline-flex justify-between">
          {beds && (
            <div className="flex flex-col items-center space-y-1">
              <FaBed className="text-xl text-stone-500" />
              <span className="text-xs">{beds} Bedrooms</span>
            </div>
          )}
          {guests && (
            <div className="flex flex-col items-center space-y-1">
              <FaUserFriends className="text-xl text-stone-500" />
              <span className="text-xs">{guests} Guests</span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
